export default __webpack_public_path__ + "static/SR USA - Absence of chemicals - Statement-208414c3452344543f4c02393e9fa2ba.pdf";